import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { PlayGroundService } from "../../services/playground/playground.service";
import "./playground.scss";
import parse from "html-react-parser";
import { chaserthumbnail } from "../../assets/images/index";


import MathExpressionNew from '../../components/common/mathjax'; // Adjust the import path as needed



interface Message {
  text: string;
  isBot: boolean;
  timestamp: Date;
}

export default function Index() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState<Message[]>([]);
  const [inputMessage, setInputMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoUrl, setVideoUrl] = useState<string>('');

  useEffect(() => {    
    
    const ChaserVideo = 'https://shoonitdatastore.file.core.windows.net/shoonit-public-files/video_files/ChaserVideo1.mp4?sp=r&st=2025-09-01T11:16:00Z&se=2026-12-31T23:00:00Z&spr=https&sv=2024-11-04&sig=JMre3%2FFPeT0PaPOVKprd1bzvjc9%2FZDcZ4%2FBfcqvS6%2Fc%3D&sr=f';

    //const ChaserVideo = 'https://shoonitdatastore.file.core.windows.net/shoonit-public-files/video_files/ChaserVideo2.mp4?sp=r&st=2025-08-31T21:00:00Z&se=2026-12-31T23:00:00Z&spr=https&sv=2024-11-04&sig=GAX88Kq1vZ5k9z72Q9LL3jBxNeWMiOGa7jx8jB%2F0kMM%3D&sr=f';

    setVideoUrl(ChaserVideo);
  }, []);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleChat = async (userMessage: string) => {
    try {
      setIsLoading(true);

      const messageId = parseInt(userMessage.trim()) || 690;      

      const PlayGroundServiceInstance: PlayGroundService = new PlayGroundService();
      const response = await PlayGroundServiceInstance.GETSOLUTIONCONTENT(messageId);

      if (response) {
        setMessages(prev => [...prev, {
          text: response.solution_content,
          isBot: true,
          timestamp: new Date()
        }]);
      }
    } catch (error) {
      console.log(error);
      setMessages(prev => [...prev, {
        text: "מצטער היתה בעיית תקשורת האם תוכל לנסות שוב...",
        isBot: true,
        timestamp: new Date()
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent | React.KeyboardEvent) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;

    
    setMessages(prev => [...prev, {
      text: inputMessage,
      isBot: false,
      timestamp: new Date()
    }]);

    await handleChat(inputMessage);
    setInputMessage("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Standard chat behavior: Enter to send, Shift+Enter for a new line.
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevents adding a new line in the textarea
      handleSubmit(e);
    }
  };

  const handlePlayButtonClick = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      // If src is already set (e.g., video was paused), just play.
      if (videoElement.currentSrc) {
        videoElement.play().catch(error => {
          if (error.name !== 'AbortError') {
            console.error("Error attempting to play video:", error);
          }
        });
        return;
      }

      // If the source isn't set, set it and wait for it to be playable.
      const onCanPlay = () => {
        videoElement.play().catch(error => {
          if (error.name !== 'AbortError') {
            console.error("Error playing video after canplay event:", error);
          }
        });
        // Clean up the event listener to avoid it firing again
        videoElement.removeEventListener('canplay', onCanPlay);
      };

      videoElement.addEventListener('canplay', onCanPlay);

      // Cache-busting: Append a unique timestamp to the URL. This forces the
      // browser to treat it as a new resource, bypassing any cache and preventing
      // it from sending the "Conditional headers" that Azure File Storage rejects.
      const cacheBustedUrl = `${videoUrl}&_cb=${new Date().getTime()}`;
      videoElement.src = cacheBustedUrl;
      videoElement.load(); // Explicitly tell the element to load the new source
      setIsPlaying(true);
    }
  };

  const captureVideoThumbnail = (videoElement: HTMLVideoElement): string => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    
    ctx.drawImage(videoElement, 0, 0);
    return canvas.toDataURL('image/jpeg', 0.8);
  };

  const handleVideoLoadedMetadata = () => {
  const videoElement = videoRef.current;
  if (videoElement) {
    videoElement.currentTime = 0; // Ensure we're at the first frame
    const thumbnailDataUrl = captureVideoThumbnail(videoElement);
    // Use thumbnailDataUrl as poster or save it
    videoElement.poster = thumbnailDataUrl;
  }
};

  return (
    <div className="chat-container">
      {/* Chat Header */}
      <div className="chat-header">
        <h1 className="header-title">שונית - איזור  ניסויים</h1>
      </div>

      {/* Chat Messages */}
      <div className="chat-messages">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`message ${message.isBot ? 'bot-message' : 'user-message'}`}
          >
            <div className="message-content">                                                      
                 <MathExpressionNew content={message.text} />        
              <span className="timestamp">
                {message.timestamp.toLocaleTimeString()}
              </span>
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="message bot-message">
            <div className="typing-indicator">
              <p>מקליד...</p>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Chat Input */}
      <div className="chat-input-container">
        <form onSubmit={handleSubmit} className="input-form">
          <textarea
            className="message-input"
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            rows={3} // Adjust the number of rows as needed
            />
          <button
            type="submit"
            disabled={isLoading}
            className={`send-button ${isLoading ? 'disabled' : ''}`}
          >
            שלח
          </button>
        </form>
      </div>

    </div>
  );
}
